// extracted by mini-css-extract-plugin
module.exports = {"container":"PageTitle_container__n0o2e","title":"PageTitle_title___Ueo_","subtitle":"PageTitle_subtitle__C0cKa"};